/**
 * Keys identifying the HITL canvas store extensions registered on the shared
 * drawing canvas (edit state, opening hover/selection, opening clipboard,
 * candidate-opening session suppression).
 */
export const ExtensionKeys = {
	edit: 'hitlEdit',
	openingHover: 'hitlOpeningHover',
	openingSelection: 'hitlOpeningSelection',
	openingClipboard: 'hitlOpeningClipboard',
	candidateOpening: 'hitlCandidateOpening',
	polygonEdit: 'hitlPolygonEdit',
} as const;
